module.exports = __webpack_public_path__ + "img/sv7on.69873449.svg";